varying vec3 vPositionW;
uniform vec3 uHeatSource;
uniform float uHeatDistance;

#define USE_SHADOWMAP
#define USE_UV 
